import React from 'react';

function About() {
    return (
        <main className="bg-dark-300 min-h-screen">

            {/* ── HERO ── */}
            <section className="relative max-w-7xl mx-auto px-4 pt-20 pb-16 text-center">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-saffron-500 opacity-10 rounded-full blur-3xl pointer-events-none" />

                <p className="text-saffron-500 font-semibold tracking-widest text-sm uppercase mb-4">
                    हमारे बारे में
                </p>
                <h1 className="font-display text-4xl md:text-5xl font-bold text-white mb-6">
                    बिहार के युवाओं का <br />
                    <span className="text-saffron-500">सबसे बड़ा सहारा</span>
                </h1>
                <p className="text-gray-400 text-lg max-w-2xl mx-auto">
                    JobFreedom की शुरुआत एक सोच से हुई — बिहार के मेहनती युवाओं को
                    सही मौका मिलना चाहिए। आज हम हजारों students को उनकी मंजिल तक पहुंचा रहे हैं।
                </p>
            </section>

            {/* ── MISSION ── */}
            <section className="bg-dark-200 py-20">
                <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-16 items-center">

                    <div>
                        <p className="text-saffron-500 font-semibold tracking-widest text-sm uppercase mb-4">
                            Our Mission
                        </p>
                        <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-6">
                            हर घर में रोजगार, <br /> हर हाथ में काम
                        </h2>
                        <p className="text-gray-400 leading-relaxed mb-6">
                            बिहार में लाखों युवा skilled हैं लेकिन उन्हें सही platform नहीं मिलता।
                            JobFreedom वो bridge है जो students को directly verified companies से जोड़ता है।
                        </p>
                        <p className="text-gray-400 leading-relaxed">
                            हमारा विश्वास है कि talent को geography से नहीं रोका जा सकता।
                            बिहार का हर युवा deserving है एक अच्छी नौकरी का।
                        </p>
                    </div>

                    {/* Stats grid */}
                    <div className="grid grid-cols-2 gap-6">
                        {[
                            { number: '10,000+', label: 'Students Placed' },
                            { number: '500+', label: 'Partner Companies' },
                            { number: '38', label: 'Districts Covered' },
                            { number: '3', label: 'Job Categories' },
                        ].map((stat, i) => (
                            <div key={i} className="bg-dark-300 border border-gray-800 rounded-2xl p-6 text-center">
                                <div className="text-saffron-500 font-display text-3xl font-bold">{stat.number}</div>
                                <div className="text-gray-400 text-sm mt-2">{stat.label}</div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

            {/* ── TEAM / COMPANY IMAGES ── */}
            <section className="max-w-7xl mx-auto px-4 py-20">
                <h2 className="font-display text-3xl font-bold text-white text-center mb-4">
                    हमारी Team
                </h2>
                <p className="text-gray-400 text-center mb-12">
                    बिहार के युवाओं के लिए काम करने वाले dedicated लोग
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {[
                        { name: 'kumar dev', role: 'Founder & CEO', location: 'Patna, Bihar', img: '/images/ceo.jpeg', position: 'object-top' },
                        { name: 'priya singh', role: 'Operations Head', location: 'Mumbai, Maharashtra', img: '/images/operation.jpg', position: 'object-top' },
                        { name: 'Ashish Ranjan', role: 'Tech Lead', location: 'Pune, Maharashtra', img: '/images/techlead.jpg', position: 'object-center' },
                    ].map((member, i) => (
                        <div key={i} className="bg-dark-200 border border-gray-800 hover:border-saffron-500 rounded-3xl p-8 text-center transition-all duration-300">
                            <div className="w-24 h-24 rounded-full mx-auto mb-6 border-2 border-saffron-500 overflow-hidden">
                                <img
                                    src={member.img}
                                    alt={member.name}
                                    className={`w-full h-full object-cover ${member.position}`}
                                />
                            </div>
                            <h3 className="text-white font-semibold text-xl mb-1">{member.name}</h3>
                            <p className="text-saffron-500 text-sm font-medium mb-2">{member.role}</p>
                            <p className="text-gray-500 text-sm">📍 {member.location}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ── COMPANY IMAGES SECTION ── */}
            <section className="bg-dark-200 py-20">
                <div className="max-w-7xl mx-auto px-4">
                    <h2 className="font-display text-3xl font-bold text-white text-center mb-4">
                        हमारे Partner Companies
                    </h2>
                    <p className="text-gray-400 text-center mb-12">
                        ये companies हमारे through Bihar के students को hire करती हैं
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {[
                            {
                                name: 'Tata Motors Plant',
                                location: 'Pune, Maharashtra',
                                hiring: 'Welder, Fitter, Helper',
                                slots: '50 Openings',
                                emoji: '🏭',
                            },
                            {
                                name: 'L&T Construction',
                                location: 'Mumbai, Maharashtra',
                                hiring: 'Electrician, Supervisor',
                                slots: '30 Openings',
                                emoji: '🏗️',
                            },
                            {
                                name: 'Bajaj Auto',
                                location: 'Pune, Maharashtra',
                                hiring: 'ITI Mechanic, Technician',
                                slots: '40 Openings',
                                emoji: '⚙️',
                            },
                            {
                                name: 'Reliance Industries',
                                location: 'Jamnagar, Gujarat',
                                hiring: 'Diploma Engineer, Helper',
                                slots: '25 Openings',
                                emoji: '🔩',
                            },
                            {
                                name: 'Mahindra Factory',
                                location: 'Nashik, Maharashtra',
                                hiring: 'Quality Control, Fitter',
                                slots: '35 Openings',
                                emoji: '🚗',
                            },
                            {
                                name: 'Godrej Industries',
                                location: 'Mumbai, Maharashtra',
                                hiring: '10th Pass Helper, Security',
                                slots: '20 Openings',
                                emoji: '🏢',
                            },
                        ].map((company, i) => (
                            <div key={i} className="bg-dark-300 border border-gray-800 hover:border-saffron-500 rounded-2xl p-6 transition-all duration-300">
                                <div className="text-4xl mb-4">{company.emoji}</div>
                                <h3 className="text-white font-semibold text-lg mb-1">{company.name}</h3>
                                <p className="text-gray-500 text-sm mb-3">📍 {company.location}</p>
                                <p className="text-gray-400 text-sm mb-3">🔹 {company.hiring}</p>
                                <span className="bg-saffron-500/20 text-saffron-400 text-xs font-semibold px-3 py-1 rounded-full">
                                    {company.slots}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── VALUES ── */}
            <section className="max-w-7xl mx-auto px-4 py-20">
                <h2 className="font-display text-3xl font-bold text-white text-center mb-12">
                    हमारी Values
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                    {[
                        { icon: '🤝', title: 'Trust', desc: 'हर student का भरोसा हमारी ताकत है' },
                        { icon: '🎯', title: 'Focus', desc: 'सिर्फ Bihar के युवाओं पर focus' },
                        { icon: '💪', title: 'Empowerment', desc: 'रोजगार से आत्मनिर्भरता' },
                        { icon: '🌟', title: 'Excellence', desc: 'हर काम में quality' },
                    ].map((val, i) => (
                        <div key={i} className="bg-dark-200 border border-gray-800 rounded-2xl p-6 text-center">
                            <div className="text-4xl mb-4">{val.icon}</div>
                            <h4 className="text-white font-semibold mb-2">{val.title}</h4>
                            <p className="text-gray-400 text-sm">{val.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

        </main>
    );
}

export default About;